import { Link, useNavigate, useParams } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { Button } from "@/shared/components/ui/Button";
import { useHousehold, useUpdateHousehold } from "@/shared/lib/households";
import { HouseholdForm } from "./HouseholdForm";

export function HouseholdEdit() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const query = useHousehold(id);
  const update = useUpdateHousehold(id ?? "");

  if (query.isLoading) {
    return (
      <Section spacing="md">
        <Container size="4xl">
          <p className="type-body-base text-text-muted">Loading…</p>
        </Container>
      </Section>
    );
  }

  if (query.isError) {
    const notFound = query.error.status === 404;
    return (
      <Section spacing="md">
        <Container size="4xl">
          <div className="flex flex-col gap-4">
            <h1 className="type-heading-lg text-text">
              {notFound ? "Household not found" : "Couldn't load household"}
            </h1>
            <Button asChild variant="outline">
              <Link to="/app/contacts/households">Back to households</Link>
            </Button>
          </div>
        </Container>
      </Section>
    );
  }

  const household = query.data!;

  return (
    <Section spacing="md">
      <Container size="4xl">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <Link
              to={`/app/contacts/households/${household.id}`}
              className="type-label-sm tracking-wider uppercase text-text-muted hover:text-text"
            >
              ← Back to household
            </Link>
            <h1 className="type-heading-lg text-text">Edit household</h1>
          </div>
          <HouseholdForm
            mode="edit"
            initialHousehold={household}
            submitLabel="Save changes"
            pending={update.isPending}
            error={update.error}
            onSubmit={(input) =>
              update.mutate(input, {
                onSuccess: () => navigate(`/app/contacts/households/${household.id}`),
              })
            }
          />
        </div>
      </Container>
    </Section>
  );
}
